export const environment = {
    production: false,
    HEALTH_URL:'https://apigateway.outsourcingcos.com/v1/ms/health/api/'
};
